import { render, staticRenderFns } from "./PersonAddFormWrapper.vue?vue&type=template&id=2eadc892&scoped=true&"
import script from "./PersonAddFormWrapper.vue?vue&type=script&lang=js&"
export * from "./PersonAddFormWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PersonAddFormWrapper.vue?vue&type=style&index=0&id=2eadc892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eadc892",
  null
  
)

export default component.exports